import { useMessage } from "@hermes/intl";
import {
  createStaticStyles,
  type Field,
  ToggleSwitch,
  type ToggleSwitchState,
} from "@hermes/ui";

import { containerBorderBlockEndStyles } from "../quick-modal";

const nearmeShortStyles = createStaticStyles.clean({
  display: "grid",
  gridTemplateColumns: "1fr",
  paddingBlockEnd: 16,
});

export const NearmeShort = ({ field }: { field: Field<ToggleSwitchState> }) => {
  const message = useMessage();

  return (
    <div css={[nearmeShortStyles, containerBorderBlockEndStyles]}>
      <ToggleSwitch
        field={field}
        label={message({
          id: "doctors-list.filters.near",
        })}
      />
    </div>
  );
};
